import InputTypesEnum from '../../../../Enums/InputTypesEnum';
import EvaluatorPaymentService from '../../../../Services/EvaluatorPaymentService';
import EvaluatorPaymentActionParamsItem from './EvaluatorPaymentActionParamsItem';

export default class VoidAndReissueWindowDescription {
  static titleForCreate = 'Void and Reissue';
  static titleForEdit = 'Void and Reissue';
  static finishButtonLabel = 'Void and Reissue';
  static itemType = EvaluatorPaymentActionParamsItem;
  static serviceFunction = (edited) => EvaluatorPaymentService.VoidAndReissue(edited);
  static waitForServiceFunction = () => false;
  static messageOnSuccess =
    'The Void and Reissue process has been started. You will receive a notification about the result in your personal notification repository.';

  static pagesInGeneralEditWizzard = [
    {
      label: 'General',
      fields: [{ fieldName: 'Reason', label: 'Comment', className: 'col-12', type: InputTypesEnum.TextBox }],
    },
  ];
}
